import { useContext } from "react";
import BalanceLockContext from "./BalanceLockContext";

const useBalanceLockContext = () => {
  const context = useContext(BalanceLockContext);
  if (context === undefined) {
    throw new Error(
      `useBalanceLockContext must be used within BalanceLockContextProvider`,
    );
  }
  return context;
};

export default useBalanceLockContext;
